module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('range', {
    attrs: {
      "label": _vm.$t('edit.sidebar.font_size'),
      "min": "0",
      "max": "10",
      "step": "0.1",
      "value": _vm.value(),
      "change": _vm.onChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-e2dec0a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/editors/FontSize.vue
 ** module id = 918
 ** module chunks = 1
 **/